import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

export interface SimpleFormSchema {
  name: string
  /** 默认为 name */
  label?: string
  required?: boolean
  type?: 'i18nInput' | 'input' | 'textarea' | 'password' | 'checkbox' | 'select'
  placeholder?: string
  options?: string[]
  showIf?: () => boolean
}

@Component({
  selector: 'simple-form',
  templateUrl: './simple-form.component.html',
  styleUrls: ['./simple-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleFormComponent implements OnInit {

  @Input() schemas: SimpleFormSchema[] = []
  @Input() valueObject = {}
  /** 密码显示为可重置状态，编辑时可使用 */
  @Input() passwordToBeReset = false

  @Output() init = new EventEmitter()

  @ViewChild('form') form

  constructor() { }

  ngOnInit() {
    this.init.emit(this)
  }

  isValid () {
    return this.form && this.form.invalid
  }

}
